import styled, { css } from 'styled-components';
import { Direction } from '../../enums';
import { mapResponsivePropToCssPropertyValues, resolveResponsiveFlexArrayProp, resolveResponsiveProp } from '../../styles/resolveResponsiveProp';
import { px } from '../../utils';
import { createShouldForwardProp } from '../utils';
function getAlignmentPropertyFromDirection(direction) {
  return direction === 'column' ? 'alignItems' : 'justifyContent';
}
function getAlignmentPropertyFromDirectionResponsiveProp(direction) {
  const directionArray = Array.isArray(direction) ? direction : Object.values(direction);
  return directionArray.map(directionElement => getAlignmentPropertyFromDirection(directionElement));
}
export const StackRoot = styled.div.withConfig({
  shouldForwardProp: createShouldForwardProp(['spacing'])
}).withConfig({
  componentId: "ds__sc-1mq625k-0"
})(["&::before{display:table;content:'';", "}"], props => resolveResponsiveProp('marginBottom', Array.isArray(props.spacing) ? [-1 * props.spacing[0], -1 * props.spacing[1]] : props.spacing));
function resolveMarginForWrapper(direction, spacing) {
  const isDirectionArray = Array.isArray(direction);
  const isSpacingArray = Array.isArray(spacing);
  if (isDirectionArray && isSpacingArray) {
    if (direction.every(directionValue => directionValue === Direction.ROW)) {
      return resolveResponsiveProp('marginLeft', spacing.map(spacingValue => spacingValue * -1));
    }
    return direction.map((directionValue, index) => directionValue === Direction.ROW ? css(["margin-left:", ";"], px(-1 * spacing[index])) : '');
  } else if (!isSpacingArray) {
    return resolveResponsiveProp('marginLeft', spacing);
  } else {
    return Object.values(direction).map((directionValue, index) => directionValue === Direction.ROW && index <= 1 ? css(["margin-left:", ";"], px(-1 * spacing[index])) : '');
  }
}
export const StackWrapper = styled.div.withConfig({
  shouldForwardProp: createShouldForwardProp(['direction', 'spacing', 'align'])
}).withConfig({
  componentId: "ds__sc-1mq625k-1"
})(["display:flex;", ";", "};", ";", ""], _ref => {
  let {
    isWrapped
  } = _ref;
  return isWrapped && resolveResponsiveProp('flexWrap', mapResponsivePropToCssPropertyValues(isWrapped, isWrappedValue => isWrappedValue ? 'wrap' : 'nowrap'));
}, _ref2 => {
  let {
    direction
  } = _ref2;
  return resolveResponsiveProp('flexDirection', direction);
}, props => props.align ? resolveResponsiveFlexArrayProp(getAlignmentPropertyFromDirectionResponsiveProp(props.direction), props.align) : '', props => resolveMarginForWrapper(props.direction, props.spacing));
function getItemAlignmentPropertyFromDirection(direction, align) {
  const directionArray = Array.isArray(direction) ? direction : Object.values(direction);
  const responsiveAlignmentProperty = directionArray.map(directionElement => directionElement === 'column' ? 'justifyContent' : 'alignItems');
  return resolveResponsiveFlexArrayProp(responsiveAlignmentProperty, align);
}
function resolveLeftMarginForItem(direction, spacing) {
  const isDirectionArray = Array.isArray(direction);
  const isSpacingArray = Array.isArray(spacing);
  if (isDirectionArray && isSpacingArray) {
    if (direction.every(directionValue => directionValue === Direction.ROW)) {
      return resolveResponsiveProp('marginLeft', spacing);
    }
    return direction.map((directionValue, index) => directionValue === Direction.ROW ? css(["margin-left:", ";"], px(spacing[index])) : '');
  } else if (!isSpacingArray) {
    return resolveResponsiveProp('marginLeft', spacing);
  } else {
    return Object.values(direction).map((directionValue, index) => directionValue === Direction.ROW && index <= 1 ? css(["margin-left:", ";"], px(spacing[index])) : '');
  }
}
export const StackItem = styled.div.withConfig({
  shouldForwardProp: createShouldForwardProp(['direction', 'spacing', 'align'])
}).withConfig({
  componentId: "ds__sc-1mq625k-2"
})(["", ";", " ", ";:empty{margin-left:0;padding-top:0;}"], _ref3 => {
  let {
    itemWidth
  } = _ref3;
  if (itemWidth !== undefined) {
    return resolveResponsiveProp('width', itemWidth);
  }
  return null;
}, _ref4 => {
  let {
    align,
    direction
  } = _ref4;
  if (align !== undefined) {
    return css(["display:flex;", ""], getItemAlignmentPropertyFromDirection(direction, align));
  }
  return null;
}, _ref5 => {
  let {
    direction,
    spacing
  } = _ref5;
  return css(["", " ", ""], resolveLeftMarginForItem(direction, spacing), resolveResponsiveProp('paddingTop', spacing));
});